import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from "react-router-dom";
import cx from 'classnames';
import _ from 'lodash';

import { TrendBarChart, TrendsPieChart } from './charts'
import { DropdownFilter } from './dropDown'

import { fetchPageMetricsForType, fetchChartMetricsForType, fetchAnalyticsChart } from 'actions/storyboardReports';
import { convertDatesToTimezone } from 'services/report.service';
import { EmptyMessage, GeographicAnalyticsHeader, getWidthForAnalyticsBar, LoadingMessage, TableInfo } from '.';
import { TableFooter } from './tableFooter';
import { fetchAnalyticsChartForLandingPage } from 'actions/landingPageReports';
import { fetchAnalyticsChartForInteractive } from 'actions/interactiveReports';
import { useReportType } from '../ReportsProvider';
import { formatDurationWithLabel, safeDivide } from '../reporthelpers';

import styles from '../report.module.scss';

export function GeographicAnalytics(props) {
  const dispatch = useDispatch();

  let { storyboardId } = useParams();
  const countries = useSelector(state => _.get(state, `storyboards.storyboard.reports.metrics.country.items`));
  const chartData = useSelector(state => _.get(state, `storyboards.storyboard.reports.metrics.country.chartItems`));
  const pagination = useSelector(state => _.get(state, `storyboards.storyboard.reports.metrics.country.pagination`));
  const loading = useSelector(state => _.get(state, 'storyboards.storyboard.reports.metrics.country.loading'));
  const [currentChart, setCurrentChart] = useState("table_view");
  const [viewOption, setViewOption] = useState({ label: 'Views', value: 'views', name: 'metricType' })
  const { reportType } = useReportType()

  useEffect(() => {
    if (props.date) {
      handlePageChange(0);
    }
  }, [props.date, reportType]);

  const handlePageChange = (page) => {
    handleFetchPageViewsReport(page);
  }

  const handleFetchPageViewsReport = (page) => {
    var request = {
      storyboard: storyboardId,
      reportType,
      metricType: "country",
      ...convertDatesToTimezone(props.date),
    }

    dispatch(fetchPageMetricsForType(request, page, 5));
    dispatch(fetchChartMetricsForType(request, 0, 6));
  }

  const handleChartChange = (value) => {
    setCurrentChart(value)
  }

  const handleArrange = (data) => {
    setViewOption(state => {
      return {
        ...state,
        label: data.label,
        value: data.value
      }
    });
  }

  return (
    <div className={styles.geographicAnalyticsWrapper}>
      <div className={styles.geographicAnalyticsContainer}>
        <TableInfo
          name="Geography Analytics"
          pagination={pagination} />

        {currentChart == "table_view" && <GeographicAnalyticsHeader />}

        {currentChart == "pie_chart_view" && <DropdownFilter disableOption={[]} arrangeOption={viewOption} handleArrange={handleArrange} />}

        {currentChart == "table_view" &&
          !loading && countries && countries.map((data, index) => {
            return <GeographicReportView data={data} loading={loading} storyboard={storyboardId} index={index} storyboardType={props.storyboardType} date={props.date}/>
          })
        }

        {(_.size(chartData) > 0 && currentChart == "pie_chart_view") &&
          <div className={styles.graphFullView}>
            <TrendsPieChart data={chartData} viewOption={viewOption} height={400} width="100%" />
          </div>
        }

        {loading && (countries && countries.length > 0) &&
          <LoadingMessage />
        }

        {(countries && countries.length == 0) && !loading &&
          <EmptyMessage />
        }
      </div>

      <TableFooter
        currentChart={currentChart}
        disableView={['graph_view']}
        handleChartChange={handleChartChange}
        handlePageChange={handlePageChange}
        pagination={pagination}
        paginationName={"Geography"}
      />
    </div>
  )
}

function GeographicReportView({ loading, storyboard, data, storyboardType, date }) {
  const dispatch = useDispatch();
  const countryAnalyticsData = useSelector(state => _.get(state, `storyboards.storyboard.reports.analytics.country.items[${data.metricType}]`));

  useEffect(() => {
    if (data.metricType) {
      var request = {
        storyboard: storyboard,
        country: data.metricType,
        ...convertDatesToTimezone(date),
      }

      if (storyboardType == "INTERACTIVE_CONTENT") {
        dispatch(fetchAnalyticsChartForInteractive(request, "country"));
      }

      if (storyboardType == "LANDING_PAGE") {
        dispatch(fetchAnalyticsChartForLandingPage(request, "country"))
      }
    }
  }, [data.metricType]);


  if (!data || data.length <= 1) {
    return false;
  }

  return (
    <div className={styles.geographicAnalyticsRow}>

      <div className={cx(styles.wrapper, styles.locationColumn)}>
        <div className={styles.headline}>{data.metricType}</div>
      </div>

      <div className={cx(styles.wrapper, styles.viewsColumn)}>
        <div className={styles.headline}>{data.views}</div>
      </div>

      <div className={cx(styles.wrapper, styles.visitorsColumn)}>
        <div className={styles.headline}>{data.visitors}</div>
      </div>

      <div className={cx(styles.wrapper, styles.avgTimeSpentColumn)}>
        <div className={styles.headline}>{formatDurationWithLabel(safeDivide(data.timeSpent, data.views)).value}</div>
      </div>

      <div className={cx(styles.wrapper, styles.timespentColumn)}>
        <div className={styles.headline}>{formatDurationWithLabel(data.timeSpent).value}</div>
      </div>

      <div className={cx(styles.wrapper, styles.pageAnalyticsView)}>
        {countryAnalyticsData && countryAnalyticsData.length > 0 ?
          <TrendBarChart data={countryAnalyticsData} width={getWidthForAnalyticsBar(countryAnalyticsData)} dataKey="views"/> : "-"
        }
      </div>
    </div>
  )
}